  var reviews_slick_config = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        dots: true
    }
    $('div.review-slider').slick(reviews_slick_config);